var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',_vm._l((_vm.data),function(d){return _c('TableDataRow',{key:d.id,staticClass:"non-selectable",attrs:{"id":d.id,"data":d,"columns":_vm.columns},nativeOn:{"click":function($event){return _vm.onRowClick(d, $event)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }